class SideCartContainerTitle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', () => this.dataset.reveal = !(this.dataset.reveal === 'true'))
  }
}

customElements.define('side-cart-container-title', SideCartContainerTitle);